export default __webpack_public_path__ + "static/media/Tree1.b2acb581.png";